export default "__VITE_PUBLIC_ASSET__55caa8ee__"